export default "__VITE_ASSET__Dnn9zRqf__";